<template>
  <div class="app-contract-summary">
    <slot name="txtBeforeLink">Laden Sie sich </slot>
      <slot name="downloadLink">
        <a class="downloadCSLink" @click.prevent="download()">hier</a>
      </slot>
    <slot name="txtAfterLink"> Ihre aktuelle Vertragszusammenfassung herunter.</slot>
  </div>
</template>
<script>

import axios from 'axios'
import FileSaver from 'file-saver'
import transaction from '@/mixins/transaction'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractSummary',
  data () {
    return {}
  },
  props: {},
  methods: {
    download: function () {
      const me = this

      axios.get('/api/document/contract-summary', {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'vertragszusammenfassung.pdf')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ])
  },
  mixins: [
    transaction('contractSummary')
  ]
}
</script>
